const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { plan: planApi } = require('@doctoroncallcom/api')
const {
  GET_PLAN_LIST,
  GET_PLAN,
  CREATE_PLAN,
  UPDATE_PLAN,
  DELETE_PLAN,
  GET_PLAN_FOR_PRICE,
} = require('./constants')

const {
  getPlanListSuccess,
  getPlanListError,
  getPlanSuccess,
  getPlanError,
  createPlanSuccess,
  createPlanError,
  updatePlanSuccess,
  updatePlanError,
  deletePlanSuccess,
  deletePlanError,
  getPlanForPriceSuccess,
  getPlanForPriceError,
} = require('./actions')

const getPlanList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PLAN_LIST),
  mergeMap(action => planApi.getPlanListApi(api, {
    skip: action.payload.skip,
    take: action.payload.take,
    search: action.payload.search,
  })
    .then(response => getPlanListSuccess(response.data))
    .catch(error => getPlanListError(error))),
)

const getPlan = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PLAN),
  mergeMap(action => planApi.getPlanApi(api, action.payload.id)
    .then(response => getPlanSuccess(response.data))
    .catch(error => getPlanError(error))),
)

const createPlan = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_PLAN),
  mergeMap(action => planApi.createPlanApi(api, action.payload.planData)
    .then(response => createPlanSuccess(response.data))
    .catch(error => createPlanError(error))),
)

const updatePlan = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PLAN),
  mergeMap(action => planApi.updatePlanApi(api, action.payload.id, action.payload.planData)
    .then(response => updatePlanSuccess(response.data))
    .catch(error => updatePlanError(error))),
)

const deletePlan = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_PLAN),
  mergeMap(action => planApi.deletePlanApi(api, action.payload.id)
    .then(response => deletePlanSuccess(response.data))
    .catch(error => deletePlanError(error))),
)

const getPlanForPriceEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PLAN_FOR_PRICE),
  mergeMap(action => planApi.getPlanForPriceApi(api, { planId: action.payload.id })
    .then(response => getPlanForPriceSuccess(response.data))
    .catch(error => getPlanForPriceError(error))),
)

module.exports = {
  getPlanList,
  getPlan,
  createPlan,
  updatePlan,
  deletePlan,
  getPlanForPriceEpic,
}
